<template>
<div class="assetDetailPill">
  <slot></slot>
  <neb-icon name="x"
    v-show="clearable"
    @click.native="onDeleteClick"
  />
</div>
</template>

<script>
import NebIcon from '@/components/Nebula/Icon'

export default {
  name: 'AssetDetailPill',

  components: {
    NebIcon
  },

  props: {
    clearable: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'action:delete'
  ],

  setup (_, { emit }) {
    const onDeleteClick = () => emit('action:delete')

    return {
      onDeleteClick
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.assetDetailPill {
  font-family: $defaultFont;
  font-size: 12px;
  color: $slate-grey;
  background-color: $ice-blue;
  border: 1px solid $light-blue;
  height: 26px;
  border-radius: 13px;
  padding: 5px 12px;
  display: inline-flex;
  align-items: center;

  .nebIcon {
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>
